const paintings = [
    {
        id: 1,
        type: "Smriti Sutra",
        items: [
            { id: 1, name: "Twin Spirit of Rain", size: "37cm x 15cm x 37cm", src: "twin.jpg", tag: "Available" },
            { id: 2, name: "The Fish Who Carried the tree", size: "40cm x 15cm x 40cm", src: "fish.jpg", tag: "Available" },
            { id: 3, name: "Love returns", size: "32cm x 30cm x 43cm", src: "love.jpg", tag: "Available" },
            { id: 4, name: "Shimmering Lies", size: "50cm x 35cm x 52cm", src: "shimmering.jpg", tag: "Available" },
            { id: 5, name: "Together We Soar", size: "35cm x 20cm x 46cm", src: "together.jpg", tag: "Sold" },
            { id: 6, name: "Song of the Flame", size: "46cm x 28cm x 48cm", src: "song.jpg", tag: "Available" },
            { id: 7, name: "Shared Wisdom", size: "38cm x 15cm x 50cm", src: "shared.jpg", tag: "Sold" },
            { id: 8, name: "Nightlight Fish", size: "49cm x 20cm x 48cm", src: "nightlight.jpg", tag: "Sold" },
            { id: 9, name: "Golden Grace", size: "35cm x 15cm x 44cm", src: "golden.jpg", tag: "Available" },
            { id: 10, name: "The Trio of Dawn", size: "63cm x 25cm x 44cm", src: "trio.jpg", tag: "Available" },
            { id: 11, name: "The Remembering Tail", size: "42cm x 12cm x 46cm", src: "tail.jpg", tag: "Sold" }
        ]
    },
    {
        id: 2,
        type: "Australian Relief",
        items: [
            { id: 1, name: "The song beneath the feathers", size: "62cm X 76 cm", src: "peacocknew.jpg", tag: "Available" },
            { id: 2, name: "In the wake of a rainbow", size: "30cm x 40cm", src: "abstract.jpg", tag: "Available" },
            { id: 3, name: "Twilight with kingfishers", size: "40cm x 40cm", src: "twokingfisher.jpg", tag: "Available" },
            { id: 4, name: "Where the cockatoo blooms", size: "30cm x 30cm", src: "cockatoo.jpg", tag: "Sold" },
            { id: 5, name: "Kingfisher's Haven", size: "30cm x 30cm", src: "kingfishersmall.jpg", tag: "Available" },
            { id: 6, name: "A Symphony of Colors", size: "46cm x 61cm", src: "lorikeet.jpg", tag: "Available" },
            { id: 7, name: "Rustic Hops", size: "42cm x 62cm", src: "kangaroo.jpg", tag: "Available" },
            { id: 8, name: "Lone Sentinel", size: "61cm x 61cm", src: "leaf1.jpg", tag: "Available" },
            { id: 9, name: "From Ash, Green", size: "46cm x 36cm", src: "leaf2.jpg", tag: "Available" },
            { id: 10, name: "Outback Red Reveries", size: "55cm x 92cm", src: "outback.jpg", tag: "Available" },
            { id: 11, name: "Enchanted Gaze", size: "64cm x 79cm", src: "eye.jpg", tag: "Available" },
            { id: 12, name: "Own the Moon", size: "57cm dia", src: "moon.jpg", tag: "Available" },
            { id: 13, name: "Silent Reverie", size: "51cm x 41cm", src: "sunrise.jpg", tag: "Sold" },
        ]
    },
    {
        id: 3,
        type: "Indian Relief",
        items: [
            { id: 1, name: "Tree of life", size: "85cm x 60cm", src: "tree2.jpg", tag: "Available" },
            { id: 2, name: "Vibrant sanctum", size: "40cm x 45cm", src: "cutout.jpg", tag: "Available" },
            { id: 3, name: "Mystic queen", size: "102cm x 76cm", src: "queen.jpg", tag: "Sold" },
            { id: 4, name: "Divine rhapsody of Ganesha  ", size: "66cm x 36cm", src: "ganesha.jpg", tag: "Sold" },
            { id: 5, name: "Tree of life", size: "68cm x 53cm", src: "tree1.jpg", tag: "Sold" },
            { id: 6, name: "Ornate gaze", size: "76cm x 51cm", src: "mirror.jpg", tag: "Sold" },
            { id: 7, name: "Nature's reflection", size: "76cm x 24cm", src: "peacockindian.jpg", tag: "Sold" },
            { id: 8, name: "Swastik", size: "40cm x 50cm", src: "swastik.jpg", tag: "Sold" },
            { id: 9, name: "Sea spirits", size: "40cm x 50cm", src: "glass.jpg", tag: "Sold" },
        ]
    },
    {
        id: 4,
        type: "Sculptures",
        items: [
            { id: 1, name: "Lorikeets dreams", size: "55cm x 30cm x 60cm", src: "dreams.jpg", tag: "Available" },
            { id: 2, name: "Flying spirit", size: "45cm x 250cm x 37cm", src: "flyingspirit.jpg", tag: "Sold" },
            { id: 3, name: "Splendid companions", size: "30cm x 30cm", src: "splendid1.jpg", tag: "Available" },
            { id: 4, name: "Splendid harmony", size: "30cm x 30cm", src: "splendid2.jpg", tag: "Available" },
            { id: 5, name: "The Golden Bowl", size: "62cm x 30cm x 35cm", src: "goldenbowl.jpg", tag: "Available" },
            { id: 6, name: "Splendid duet", size: "35cm x 20cm x 30cm", src: "duet.jpg", tag: "Available" },
        ]
    }
];


export default paintings;